import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Coins } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const GrantCell = ({ userId, onGranted }) => {
  const [amount, setAmount] = useState("");
  const [granting, setGranting] = useState(false);

  const grant = async () => {
    const n = parseFloat(amount);
    if (Number.isNaN(n) || n <= 0 || n > 1000) {
      toast.error("Enter an amount between $0.01 and $1000");
      return;
    }
    setGranting(true);
    try {
      const { data } = await api.post("/admin/grant-credits", { user_id: userId, amount: n });
      toast.success(data.message);
      setAmount("");
      onGranted(userId, data.credits);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Grant failed");
    } finally {
      setGranting(false);
    }
  };

  return (
    <div className="flex items-center gap-2 justify-end">
      <div className="relative w-24">
        <span className="absolute left-2 top-1/2 -translate-y-1/2 text-muted-foreground font-mono text-xs">$</span>
        <Input type="number" min="0.01" max="1000" step="0.01" value={amount} placeholder="0.00"
          onChange={(e) => setAmount(e.target.value)} data-testid={`grant-amount-${userId}`}
          className="pl-5 h-8 bg-background border-border rounded-sm font-mono text-xs focus-visible:ring-[#007AFF]" />
      </div>
      <Button size="sm" onClick={grant} disabled={granting} data-testid={`grant-btn-${userId}`}
        className="h-8 bg-[#007AFF] hover:bg-[#0066d6] text-white rounded-sm gap-1.5 text-xs font-semibold">
        <Coins className="w-3.5 h-3.5" /> {granting ? "…" : "Grant"}
      </Button>
    </div>
  );
};
